import angular from 'angular';
import uiRouter from 'angular-ui-router';

import shopComponent from './shop.component';

import Beacon from './beacon/beacon';
import Register from './register/register';

const shopModule = angular.module('tinaba.components.shop', [
  uiRouter,
  Beacon.name,
  Register.name
])

.config(($stateProvider) => {
  'ngInject';

  $stateProvider
    .state('shop', {
      url: '/shop',
      template: '<shop></shop>',
      redirect: 'shop.register'
    });
})

.component('shop', shopComponent);

export default shopModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/shop/shop.js
 **/